import { z } from 'zod'

export const EmailInputSchema = z.object({
  email: z.string().min(1, 'メールアドレスを入力してください').email('正しいメールアドレスを入力してください'),
})
export type EmailInputFormData = z.infer<typeof EmailInputSchema>

export const VerificationCodeSchema = z.object({
  code: z
    .string()
    .min(1, '認証コードを入力してください')
    .length(6, '認証コードは6桁で入力してください')
    .regex(/^\d{6}$/, '認証コードは半角数字6桁で入力してください'),
})
export type VerificationCodeFormData = z.infer<typeof VerificationCodeSchema>
